import * as ScreenComponents from '../screens/index.js'

export const routesArr = [
    {
        path: '/',
        screen: ScreenComponents.Dashboard,
        checker: false
    },
    {
        path: '/sku-lookup',
        screen: ScreenComponents.Distributor2,
        checker: true
    },
    {
        path: '/pending-sku-lookup',
        screen: ScreenComponents.PendingSkuLookUp,
        checker: true
    },
    {
        path: '/sku-lookup-nu',
        screen: ScreenComponents.SkuLookUpNu,
        checker: true
    },
    {
        path: '/style',
        screen: ScreenComponents.Style,
        checker: true
    },
    {
        path: '/product-info',
        screen: ScreenComponents.ProductInfoNew,
        checker: true
    },
    {
        path: '/product-info/edit/:id',
        screen: ScreenComponents.Product,
        checker: true
    },
    {
        path: '/product-info/getAll',
        screen: ScreenComponents.ProductList,
        checker: true
    },
    {
        path: '/customer-info',
        screen: ScreenComponents.CustomerNew,
        checker: true
    },
    {
        path: '/customer-New-Info/add',
        screen: ScreenComponents.CustomerNewForm,
        checker: true
    },
    {
        path: '/customer-New-Info/edit/:id',
        screen: ScreenComponents.CustomerNew,
        checker: true
    },
    {
        path: '/sales-person',
        screen: ScreenComponents.SalePerson,
        checker: true
    },
    {
        path: '/region',
        screen: ScreenComponents.Region,
        checker: true
    },
    {
        path: '/state',
        screen: ScreenComponents.State,
        checker: true
    },
    {
        path: '/country',
        screen: ScreenComponents.Country,
        checker: true
    },
    {
        path: '/city',
        screen: ScreenComponents.City,
        checker: true
    },
    {
        path: '/cat',
        screen: ScreenComponents.RegionSale,
        checker: true
    },
    {
        path: '/shipvia',
        screen: ScreenComponents.ShipVia,
        checker: true
    },
    {
        path: '/shipmethod',
        screen: ScreenComponents.ShippingMethod,
        checker: true
    },
    {
        path: '/freightterm',
        screen: ScreenComponents.FreightTerm,
        checker: true
    },
    {
        path: '/berganbill',
        screen: ScreenComponents.BerganBilling,
        checker: true
    },
    {
        path: '/courierservice',
        screen: ScreenComponents.CourierService,
        checker: true
    },
    {
        path: '/adminuser',
        screen: ScreenComponents.AdminUser,
        checker: true
    },
    {
        path: '/userrights',
        screen: ScreenComponents.UserRights,
        checker: true
    },
    {
        path: '/paymentterm',
        screen: ScreenComponents.Paymentterm,
        checker: true
    },
    {
        path: '/admin-menu',
        screen: ScreenComponents.AdminMenu,
        checker: true
    },
    {
        path: '/tax-setup',
        screen: ScreenComponents.TaxSetup,
        checker: true
    },
    {
        path: '/chartofacct',
        screen: ScreenComponents.ChartOfAccount,
        checker: true
    },
    {
        path: '/company',
        screen: ScreenComponents.Company,
        checker: true
    },
    {
        path: '/order-status',
        screen: ScreenComponents.OrderStatus,
        checker: true
    },
    {
        path: '/pt-status',
        screen: ScreenComponents.PickTicketStatus,
        checker: true
    },
    {
        path: '/ship-status',
        screen: ScreenComponents.ShipStatus,
        checker: true
    },
    {
        path: '/acct-period',
        screen: ScreenComponents.FiscalYear,
        checker: true
    },
    {
        path: '/accounttype',
        screen: ScreenComponents.AccountType,
        checker: true
    },
    {
        path: '/wash',
        screen: ScreenComponents.Wash,
        checker: true
    },
    {
        path: '/wash-type',
        screen: ScreenComponents.WashType,
        checker: true
    },
    {
        path: '/fit-cut',
        screen: ScreenComponents.Cut,
        checker: true
    },
    {
        path: '/fabric',
        screen: ScreenComponents.Fabric,
        checker: true
    },
    {
        path: '/fit-category',
        screen: ScreenComponents.FitCategory,
        checker: true
    },
    {
        path: '/gender',
        screen: ScreenComponents.Gender,
        checker: true
    },
    {
        path: '/gender-cat',
        screen: ScreenComponents.GenderCategory,
        checker: true
    },
    {
        path: '/paymentType',
        screen: ScreenComponents.PaymentType,
        checker: true
    },
    {
        path: '/rise',
        screen: ScreenComponents.Rise,
        checker: true
    },
    {
        path: '/inseamlabel',
        screen: ScreenComponents.InseamLabel,
        checker: true
    },
    {
        path: '/productclass',
        screen: ScreenComponents.ProductClass,
        checker: true
    },
    {
        path: '/productstatus',
        screen: ScreenComponents.ProductStatus,
        checker: true
    },
    {
        path: '/itemtype',
        screen: ScreenComponents.ItemType,
        checker: true
    },
    {
        path: '/rise-label',
        screen: ScreenComponents.RiseLabel,
        checker: true
    },
    {
        path: '/season',
        screen: ScreenComponents.Season,
        checker: true
    },
    {
        path: '/inseam',
        screen: ScreenComponents.Inseam,
        checker: true
    },
    {
        path: '/size',
        screen: ScreenComponents.Size,
        checker: true
    },
    {
        path: '/return-reason',
        screen: ScreenComponents.ReturnReason,
        checker: true
    },
    {
        path: '/location',
        screen: ScreenComponents.AdminLocation,
        checker: true
    },
    {
        path: '/sales-targets',
        screen: ScreenComponents.SalesTarget,
        checker: true
    },
    {
        path: '/order-status',
        screen: ScreenComponents.OrderStatus,
        checker: true
    },
    {
        path: '/vendor',
        screen: ScreenComponents.Vendor,
        checker: true
    },
    {
        path: '/vendorCategory',
        screen: ScreenComponents.VendorCategory,
        checker: true
    },
    {
        path: '/invoice-list',
        screen: ScreenComponents.InvoiceList,
        checker: true
    },
    {
        path: '/item-receipt/list',
        screen: ScreenComponents.ItemReceiptList,
        checker: true
    },
    {
        path: '/credit-note/edit/:saleReturnId?',
        screen: ScreenComponents.ItemCredit,
        checker: true
    },
    {
        path: '/credit-note/list',
        screen: ScreenComponents.ItemCreditNoteList,
        checker: true
    },
    {
        path: '/item-transfer/list',
        screen: ScreenComponents.ItemTransferList,
        checker: true
    },
    {
        path: '/item-transfer/add',
        screen: ScreenComponents.ItemTransfer,
        checker: true
    },
    {
        path: '/item-transfer/edit/:id',
        screen: ScreenComponents.ItemTransfer,
        checker: true
    },
    {
        path: '/inventory-adjustment',
        screen: ScreenComponents.InventoryAdjustment,
        checker: true
    },
    {
        path: '/inventory-adjustment/edit/:id',
        screen: ScreenComponents.InventoryAdjustment,
        checker: true
    },
    {
        path: '/inventory-adjustment/list',
        screen: ScreenComponents.InventoryAdjustmentNewList,
        checker: true
    },
    {
        path: '/bill/list',
        screen: ScreenComponents.BillList,
        checker: true
    },
    {
        path: '/vendor-info/getAll',
        screen: ScreenComponents.VendorList,
        checker: true
    },
    {
        path: '/bill/add',
        screen: ScreenComponents.Bill,
        checker: true
    },
    {
        path: '/bill/edit/:id',
        screen: ScreenComponents.Bill,
        checker: true
    },
    {
        path: '/vendor/edit/:id',
        screen: ScreenComponents.Vendor,
        checker: true
    },
    {
        path: '/product-list',
        screen: ScreenComponents.ProductReportList,
        checker: true
    },
    {
        path: '/order-report',
        screen: ScreenComponents.OrderReprot,
        checker: true
    },
    {
        path: '/return-type',
        screen: ScreenComponents.ReturnType,
        checker: true
    },
    {
        path: '/fabric-composition',
        screen: ScreenComponents.FabricComposition,
        checker: true
    },
    {
        path: '/fabric-class-2',
        screen: ScreenComponents.FabricClass2,
        checker: true
    },
    {
        path: '/fabric-class',
        screen: ScreenComponents.FabricClass,
        checker: true
    },
    {
        path: '/fabric-type',
        screen: ScreenComponents.FabricType,
        checker: true
    },
    {
        path: '/fabric-usable',
        screen: ScreenComponents.FabricUsable,
        checker: true
    },
    {
        path: '/charge-back-type/edit/:id',
        screen: ScreenComponents.Product,
        checker: true
    },
    {
        path: '/charge-back-type/getAll',
        screen: ScreenComponents.ChargeBackTypeList,
        checker: true
    },
    {
        path: '/commit-criteria',
        screen: ScreenComponents.CommitCriteria,
        checker: true
    },
    {
        path: '/charge-back-type',
        screen: ScreenComponents.ChargeBackType,
        checker: true
    },
    {
        path: '/customer-payment',
        screen: ScreenComponents.CustomerPayment,
        checker: true
    },
    {
        path: '/customer-payment/add',
        screen: ScreenComponents.CustomerPayment,
        checker: true
    },
    {
        path: '/customer-payment/edit/:id',
        screen: ScreenComponents.CustomerPayment,
        checker: true
    },
    {
        path: '/Payment-Header/list',
        screen: ScreenComponents.PaymentHeaderList,
        checker: true
    },
    {
        path: '/Pending-POD',
        screen: ScreenComponents.PendingPOD,
        checker: true
    },
    {
        path: '/paymenttype',
        screen: ScreenComponents.PaymentType,
        checker: true
    },
    {
        path: '/sales-target-report',
        screen: ScreenComponents.SalesTargetRetport,
        checker: true
    },
    {
        path: '/admin-module',
        screen: ScreenComponents.AdminModule,
        checker: true
    },
    {
        path: '/customertype',
        screen: ScreenComponents.CustomerType,
        checker: true
    },
    {
        path: '/ProductDetail',
        screen: ScreenComponents.ProductDetail,
        checker: true
    },
    {
        path: '/term-for-print',
        screen: ScreenComponents.TermForPrint,
        checker: true
    },
    {
        path: '/admin-job',
        screen: ScreenComponents.AdminJob,
        checker: true
    },
    {
        path: '/admin-discount',
        screen: ScreenComponents.AdminDiscount,
        checker: true
    },
    {
        path: '/factor',
        screen: ScreenComponents.Factor,
        checker: true
    },
    {
        path: '/admin-menu-type',
        screen: ScreenComponents.AdminMenuType,
        checker: true
    },
    {
        path: '/paymethodtype',
        screen: ScreenComponents.PaymentMethodType,
        checker: true
    },
    {
        path: '/admin-currency',
        screen: ScreenComponents.AdminCurrency,
        checker: true
    },
    {
        path: '/admin-bargan-Payment-Term',
        screen: ScreenComponents.BarganPaymentTerm,
        checker: true
    },
    {
        path: '/bill-payments/list',
        screen: ScreenComponents.BillPaymentList,
        checker: true
    },
    {
        path: '/bill-payments/add',
        screen: ScreenComponents.BillPayment,
        checker: true
    },
    {
        path: '/bill-payments/edit/:id',
        screen: ScreenComponents.BillPayment,
        checker: true
    },
    {
        path: '/credit-memo/list',
        screen: ScreenComponents.CreditMemoList,
        checker: true
    },
    {
        path: '/credit-memo/add',
        screen: ScreenComponents.CreditMemo,
        checker: true
    },
    {
        path: '/credit-memo/edit/:id',
        screen: ScreenComponents.CreditMemo,
        checker: true
    },
    {
        path: '/return-region-wise',
        screen: ScreenComponents.OmsReturn,
        checker: true
    },
    {
        path: '/shipped-region-wise',
        screen: ScreenComponents.OmsShipping,
        checker: true
    },
    {
        path: '/pod-region-wise',
        screen: ScreenComponents.OmsPendingPOD,
        checker: true
    },
    {
        path: '/pending-region-wise',
        screen: ScreenComponents.OmsPendingOrder,
        checker: true
    },
    {
        path: '/booked-region-wise',
        screen: ScreenComponents.OmsBooking,
        checker: true
    },
    {
        path: '/scm_brand',
        screen: ScreenComponents.ScmBrand,
        checker: true
    },
    {
        path: '/business-dashboard',
        screen: ScreenComponents.BusinessDashboard,
        checker: true
    },
    {
        path: '/customer-refund',
        screen: ScreenComponents.CustomerRefund,
        checker: true
    },
    {
        path: '/customer-refund/add',
        screen: ScreenComponents.CustomerRefund,
        checker: true
    },
    {
        path: '/customer-refund/edit/:id',
        screen: ScreenComponents.CustomerRefund,
        checker: true
    },
    {
        path: '/customer-refund/list',
        screen: ScreenComponents.customerRefundList,
        checker: true
    },
    {
        path: '/journal-voucher',
        screen: ScreenComponents.JournalVoucher,
        checker: true
    },
    {
        path: '/journal-voucher/add',
        screen: ScreenComponents.JournalVoucher,
        checker: true
    },
    {
        path: '/journal-voucher/edit/:id',
        screen: ScreenComponents.JournalVoucher,
        checker: true
    },
    {
        path: '/journal-voucher/list',
        screen: ScreenComponents.JournalVoucherList,
        checker: true
    },
    {
        path: '/scm-figure',
        screen: ScreenComponents.ScmFigure,
        checker: true
    },
    {
        path: '/distributor',
        screen: ScreenComponents.Distributor,
        checker: true
    },
    {
        path: '/oms-stock-summary',
        screen: ScreenComponents.OmsStockSummary,
        checker: true
    },
    {
        path: '/immediate-ots-by-size',
        screen: ScreenComponents.ImediateOtsBySize,
        checker: true
    },
    {
        path: '/immediate-ots-by-size-2',
        screen: ScreenComponents.ImediateOtsBySize2,
        checker: true
    },
    {
        path: '/immediate-ots',
        screen: ScreenComponents.ImediateOtsBySize3,
        checker: true
    },
    {
        path: '/total-ots',
        screen: ScreenComponents.TotalOts,
        checker: true
    },
    {
        path: '/oms-stock-detail',
        screen: ScreenComponents.OmsStockDetails,
        checker: true
    },
    {
        path: '/payment',
        screen: ScreenComponents.Payment,
        checker: true
    },
    {
        path: '/transfer/add',
        screen: ScreenComponents.FundTransfer,
        checker: true
    },
    {
        path: '/transfer/edit/:id',
        screen: ScreenComponents.FundTransfer,
        checker: true
    },
    {
        path: '/transfer/list',
        screen: ScreenComponents.FundTransferList,
        checker: true
    },
    {
        path: '/sales-report',
        screen: ScreenComponents.SalesReport,
        checker: true
    },
    {
        path: '/new-sales-report',
        screen: ScreenComponents.NewSalesReport,
        checker: true
    },
    {
        path: '/bill-direct-payments/list',
        screen: ScreenComponents.BillDirectPaymentList,
        checker: true
    },
    {
        path: '/bill-direct-payments/add',
        screen: ScreenComponents.BillDirectPayment,
        checker: true
    },
    {
        path: '/bill-direct-payments/edit/:id',
        screen: ScreenComponents.BillDirectPayment,
        checker: true
    },
    {
        path: '/deposit/add',
        screen: ScreenComponents.Deposit,
        checker: true
    },
    {
        path: '/deposit/edit/:id',
        screen: ScreenComponents.Deposit,
        checker: true
    },
    {
        path: '/deposit/list',
        screen: ScreenComponents.DepositList,
        checker: true
    },
    {
        path: '/customer-category',
        screen: ScreenComponents.CustomerCategory,
        checker: true
    },
    {
        path: '/customer-payment-ledger',
        screen: ScreenComponents.CustomerPaymentLedger,
        checker: true
    },
    {
        path: '/oms-stock-style-inventory',
        screen: ScreenComponents.OmsStockSummaryInitial,
        checker: true
    },
    {
        path: '/oms-stock-style-inventory-detail',
        screen: ScreenComponents.OmsStockSummaryStyle,
        checker: true
    },
    {
        path: '/product-type',
        screen: ScreenComponents.ProductType,
        checker: true
    },
    {
        path: '/quick-po-lookup',
        screen: ScreenComponents.POLookup,
        checker: true
    },
    {
        path: '/Order-shipment-report',
        screen: ScreenComponents.OrderReport,
        checker: true
    },
    {
        path: '/New-order-shipment-report',
        screen: ScreenComponents.NewOrderReport,
        checker: true
    },
    {
        path: '/customer-category',
        screen: ScreenComponents.CustomerCategory,
        checker: true
    },
    {
        path: '/upc-setup',
        screen: ScreenComponents.UpcSetup,
        checker: true
    },
    {
        path: '/b-grade-stock',
        screen: ScreenComponents.B_Grade_Stock,
        checker: true
    },
    {
        path: '/bill-credit/list',
        screen: ScreenComponents.BillCreditList,
        checker: true
    },
    {
        path: '/bill-credit/add',
        screen: ScreenComponents.BillCredit,
        checker: true
    },
    {
        path: '/bill-credit/edit/:id',
        screen: ScreenComponents.BillCredit,
        checker: true
    },
    {
        path: '/shipped-summary',
        screen: ScreenComponents.ShippedSummary,
        checker: true
    },
    {
        path: '/shipped-detail',
        screen: ScreenComponents.ShippedDetailReport,
        checker: true
    },
    {
        path: '/booked-detail-report',
        screen: ScreenComponents.BookDetail,
        checker: true
    },
    {
        path: '/booked-order-summary-report',
        screen: ScreenComponents.BookSummary,
        checker: true
    },
    {
        path: '/pending-order-summary-report',
        screen: ScreenComponents.PendingSummary,
        checker: true
    },
    {
        path: '/pending-detail-summary-report',
        screen: ScreenComponents.PendingDetailReport,
        checker: true
    },
    {
        path: '/return-summary',
        screen: ScreenComponents.ReturnSummary,
        checker: true
    },
    {
        path: '/sales-return',
        screen: ScreenComponents.SalesReturnReport,
        checker: true
    },
    {
        path: '/sales-invoice-report',
        screen: ScreenComponents.SalesInvoiceReport,
        checker: true
    },
    {
        path: '/booked-style-wise',
        screen: ScreenComponents.BookedStyleWise,
        checker: true
    },
    {
        path: '/pending-style-wise',
        screen: ScreenComponents.PendingStyleWise,
        checker: true
    },
    {
        path: '/shipped-style-wise',
        screen: ScreenComponents.ShippedStyleWise,
        checker: true
    },
    {
        path: '/pod-style-wise',
        screen: ScreenComponents.PODStyleWise,
        checker: true
    },
    {
        path: '/return-style-wise',
        screen: ScreenComponents.ReturnStyleWise,
        checker: true
    },
    {
        path: '/product-report',
        screen: ScreenComponents.ProductReport,
        checker: true
    },
    {
        path: '/sale-order',
        screen: ScreenComponents.SaleOrder,
        checker: true
    },
    {
        path: '/sale-order-list',
        screen: ScreenComponents.SaleOrderList,
        checker: true
    },
    {
        path: '/order-shipment',
        screen: ScreenComponents.orderShipmentNew,
        checker: true
    },
    {
        path: '/order-shipment-new-list',
        screen: ScreenComponents.orderShipmentListNew,
        checker: true
    },
    {
        path: '/sale-order-adjustment-new',
        screen: ScreenComponents.SaleOrderAdjustmentNew,
        checker: true
    },
    {
        path: '/sale-order-adjustment-new-list',
        screen: ScreenComponents.SaleOrderAdjustmentNewList,
        checker: true
    },
    {
        path: '/customer-info/list',
        screen: ScreenComponents.CustomerNewList,
        checker: true
    },
    {
        path: '/create-pick-ticket',
        screen: ScreenComponents.PickTicketSummary,
        checker: true
    },
    {
        path: '/query-tool',
        screen: ScreenComponents.QueryTool,
        checker: true
    },
    {
        path: '/update-tool',
        screen: ScreenComponents.UpdateTool,
        checker: true
    },
    {
        path: '/relocate-items',
        screen: ScreenComponents.RelocateItems,
        checker: true
    },
    {
        path: '/return-authorization',
        screen: ScreenComponents.ReturnAuthorization,
        checker: true
    },
    {
        path: '/return-authorization-list',
        screen: ScreenComponents.ReturnAuthList,
        checker: true
    },
    {
        path: '/Pending-POD-summary-report',
        screen: ScreenComponents.PendingPodSummary,
        checker: true
    },
    {
        path: '/Pending-POD-summary-ar',
        screen: ScreenComponents.PendingPodSummaryAr,
        checker: true
    },
    {
        path: '/item-receipt',
        screen: ScreenComponents.ItemReceiptNew,
        checker: true
    },
    {
        path: '/item-receipt-new',
        screen: ScreenComponents.ItemReceiptNew,
        checker: true
    },
    {
        path: '/item-receipt-list-new',
        screen: ScreenComponents.ItemReceiptListNew,
        checker: true
    },
    {
        path: '/credit-note',
        screen: ScreenComponents.CreditNote,
        checker: true
    },
    {
        path: '/pick-ticket-summary-report',
        screen: ScreenComponents.PtSummary,
        checker: true
    },
    {
        path: '/order-adjustment-report',
        screen: ScreenComponents.OrderAdjustmentReport,
        checker: true
    },
    {
        path: '/order-adjustment-detail-report',
        screen: ScreenComponents.OrderAdjDetail,
        checker: true
    },
    {
        path: '/invoice',
        screen: ScreenComponents.InvoiceNew,
        checker: true
    },
    {
        path: '/pick-ticket-detail-report',
        screen: ScreenComponents.PtDetail,
        checker: true
    },
    {
        path: '/setup-new',
        screen: ScreenComponents.UpcSetup1,
        checker: true
    },
    {
        path: '/credit-memo-report',
        screen: ScreenComponents.CreditMemoReport,
        checker: true
    },
    {
        path: '/credit-open-invoice-detail',
        screen: ScreenComponents.CreditOpenInvoicedetailReport,
        checker: true
    },
    {
        path: '/sale-adjustment-report',
        screen: ScreenComponents.SalesAdjustmentReport,
        checker: true
    },
    {
        path: '/control-sheet',
        screen: ScreenComponents.ControlSheet,
        checker: true
    },
    {
        path: '/customer-information',
        screen: ScreenComponents.CustomerInfo,
        checker: true
    },
    {
        path: '/product-information',
        screen: ScreenComponents.ProductInfo,
        checker: true
    },
    {
        path: '/return-detail',
        screen: ScreenComponents.ReturnDetailReport,
        checker: true
    },
    {
        path: '/customer-payment-report',
        screen: ScreenComponents.customerRefundReport,
        checker: true
    },
    {
        path: '/customer-refund-report',
        screen: ScreenComponents.CustomerRefundReportNew,
        checker: true
    },
    {
        path: '/intransit-Report',
        screen: ScreenComponents.IntransitReport,
        checker: true
    },
    {
        path: '/payment-receipt-report',
        screen: ScreenComponents.PaymentReceiptReport,
        checker: true
    },
    {
        path: '/production-Report',
        screen: ScreenComponents.ProductionReport,
        checker: true
    },
    {
        path: '/ots-dashboard',
        screen: ScreenComponents.OTSDashboard,
        checker: true
    },
    {
        path: '/customer-balances',
        screen: ScreenComponents.CustomerBalances,
        checker: true
    },
    {
        path: '/international-order',
        screen: ScreenComponents.InternationalOrder,
        checker: true
    },
    {
        path: '/canada-order',
        screen: ScreenComponents.CanadaOrder,
        checker: true
    },
    {
        path: '/purchase_bill',
        screen: ScreenComponents.PurchaseBill,
        checker: true
    },
    {
        path: '/cit-report',
        screen: ScreenComponents.CitReport,
        checker: true
    },
    {
        path: '/credit-print-report',
        screen: ScreenComponents.CreditPrintReport,
        checker: true
    },
    {
        path: '/dl-Showroom-Report',
        screen: ScreenComponents.DlShowroom,
        checker: true
    },
    {
        path: '/inventory-report',
        screen: ScreenComponents.InventoryReport,
        checker: true
    },
    {
        path: '/dsco-invoice-report',
        screen: ScreenComponents.DscoInvoiceReport,
        checker: true
    },
    {
        path: '/pod-detail-report',
        screen: ScreenComponents.PODDetail,
        checker: true
    },
    {
        path: '/season-year',
        screen: ScreenComponents.SeasonYear,
        checker: true
    },
    {
        path: '/sales-person/list',
        screen: ScreenComponents.SalesPersonList,
        checker: true
    },
    {
        path: '/invoice-email',
        screen: ScreenComponents.InvoiceEmail,
        checker: true
    },
    {
        path: '/update-product',
        screen: ScreenComponents.UpdateProductInfo,
        checker: true
    },
    {
        path: '/location-wise-report',
        screen: ScreenComponents.LocationWise,
        checker: true
    },
    {
        path: '/commission-report',
        screen: ScreenComponents.CommissionReport,
        checker: true
    },
    {
        path: '/product-information-by-size',
        screen: ScreenComponents.ProductInfoBySize,
        checker: true
    },
    {
        path: '/good-required',
        screen: ScreenComponents.GoodRequired,
        checker: true
    },
    {
        path: '/Ar-aging-summary',
        screen: ScreenComponents.ArAgingSummary,
        checker: true
    },
    {
        path: '/inter-log',
        screen: ScreenComponents.InterLog,
        checker: true
    },
    {
        path: '/total-ots-by-size',
        screen: ScreenComponents.TotalOTSbySize,
        checker: true
    },
    {
        path: '/customer-payment-ledger-AR',
        screen: ScreenComponents.CustomerPaymentLedgerAR,
        checker: true
    },
    {
        path: '/select-query',
        screen: ScreenComponents.SelectQuery,
        checker: true
    },
    {
        path: '/invoice-pending',
        screen: ScreenComponents.InvoicePending,
        checker: true
    },
    {
        path: '/income-statement',
        screen: ScreenComponents.IncomeStatement,
        checker: true
    },
    {
        path: '/routines',
        screen: ScreenComponents.Routine,
        checker: true
    },
    {
        path: '/routine-order',
        screen: ScreenComponents.RoutineOrder,
        checker: true
    },
    {
        path: '/stock-update',
        screen: ScreenComponents.StockUpdate,
        checker: true
    },
    {
        path: '/income-detail',
        screen: ScreenComponents.IncomeDetail,
        checker: true
    },
    {
        path: '/vendor-ledger',
        screen: ScreenComponents.VenderLedger,
        checker: true
    },
    {
        path: '/balance-sheet',
        screen: ScreenComponents.BalanceSheet,
        checker: true
    },
    {
        path: '/upc-report',
        screen: ScreenComponents.UPCReport,
        checker: true
    },
    {
        path: '/balance-detail',
        screen: ScreenComponents.BalanceDetail,
        checker: true
    },
    {
        path: '/do-not-commit',
        screen: ScreenComponents.DoNotCommit,
        checker: true
    },
    {
        path: '/control-sheet-log',
        screen: ScreenComponents.ControlSheetLog,
        checker: true
    },
    {
        path: '/product-to-bergen',
        screen: ScreenComponents.ProductToBergen,
        checker: true
    },
    {
        path: '/ra-to-bergen',
        screen: ScreenComponents.RAToBergen,
        checker: true
    },
    {
        path: '/ra-to-bergen2',
        screen: ScreenComponents.RAToBergen2,
        checker: true
    },
    {
        path: '/pt-uk-to-bergen',
        screen: ScreenComponents.PtToBergen,
        checker: true
    },
    {
        path: '/packing-list-to-bergen',
        screen: ScreenComponents.AsnToBergen,
        checker: true
    },
    {
        path: '/bergen-edi',
        screen: ScreenComponents.BergenEdi,
        checker: true
    },
    {
        path: '/stitchfix-edi',
        screen: ScreenComponents.StitchFixEdi,
        checker: true
    },
    {
        path: '/payment-ledger-summary-report',
        screen: ScreenComponents.PaymentLedgerSummaryReport,
        checker: true
    },
    {
        path: '/oms-style-report',
        screen: ScreenComponents.OMSStyleReport,
        checker: true
    },
    {
        path: '/oms-wash-report',
        screen: ScreenComponents.OMSWashReport,
        checker: true
    },
    {
        path: '/product-image-report',
        screen: ScreenComponents.ProductImageReport,
        checker: true
    },
    {
        path: '/transaction-ledger',
        screen: ScreenComponents.StyleLedger,
        checker: true
    },
    {
        path: '/chart-of-account-report',
        screen: ScreenComponents.ChartofAccountReport,
        checker: true
    },
    {
        path: '/style-oms-report',
        screen: ScreenComponents.OmsStyleReportNew,
        checker: true
    },
    {
        path: '/wash-oms-report',
        screen: ScreenComponents.OmsWashReportNew,
        checker: true
    },
    {
        path: '/style-shot',
        screen: ScreenComponents.StyleShot,
        checker: true
    },
    {
        path: '/avalara-invoice',
        screen: ScreenComponents.AvalaraInvoice,
        checker: true
    },
    {
        path: '/style-distro',
        screen: ScreenComponents.StyleDistro,
        checker: true
    },
    {
        path: '/vendor-summary',
        screen: ScreenComponents.VendorSummary,
        checker: true
    },
    {
        path: '/expense',
        screen: ScreenComponents.Expense,
        checker: true
    },
    {
        path: '/ar-inventory',
        screen: ScreenComponents.ARInventory,
        checker: true
    },
    {
        path: '/inventory-valuation',
        screen: ScreenComponents.InventoryValuation,
        checker: true
    },
    {
        path: '/journal-ledger',
        screen: ScreenComponents.JournalLedger,
        checker: true
    },
    {
        path: '/journal-ledger-new',
        screen: ScreenComponents.JournalLedgerNew,
        checker: true
    },
    {
        path: '/General-ledger',
        screen: ScreenComponents.GeneralLedger,
        checker: true
    },
    {
        path: '/oms-stock-summary-ats',
        screen: ScreenComponents.OmsStockSummaryAts,
        checker: true
    },
    {
        path: '/pending-order-availability-by-size',
        screen: ScreenComponents.PickTicketDetail,
        checker: true
    },
    {
        path: '/stock-style-wise',
        screen: ScreenComponents.StockStyleWise,
        checker: true
    },
    {
        path: '/ar-aging-detail',
        screen: ScreenComponents.CustomerPaymentLedgerNew,
        checker: true
    },
    {
        path: '/balance-sheet-new',
        screen: ScreenComponents.BalanceSheetNew,
        checker: true
    },
    {
        path: '/ap-aging-detail',
        screen: ScreenComponents.APAgingDetail,
        checker: true
    },
    {
        path: '/income-statement-new',
        screen: ScreenComponents.IncomeStatementNew,
        checker: true
    },
    {
        path: '/sales-target-dashboard',
        screen: ScreenComponents.SalesTargetRetportDashboard,
        checker: true
    },
    {
        path: '/pay-check',
        screen: ScreenComponents.CheckPay,
        checker: true
    },
    {
        path: '/crm-sku-wise',
        screen: ScreenComponents.CrmSkuWise,
        checker: true
    },
    {
        path: '/crm-report',
        screen: ScreenComponents.CRMReport,
        checker: true
    },
    {
        path: '/transaction-lock',
        screen: ScreenComponents.TransactionLock,
        checker: true
    },
    {
        //ExtraProp : modalValue
        path: '/sales-target-report-saleperson',
        screen: ScreenComponents.SalesTargetReportSalePerson,
        checker: true
    },
    {
        path: '/charge-back-detail',
        screen: ScreenComponents.ChargeBackDetail,
        checker: true
    },
    {
        path: '/forget-password',
        screen: ScreenComponents.ForgetPassword,
        checker: true
    },
    {
        path: '/upc-to-itemcode',
        screen: ScreenComponents.UpcToItemCode,
        checker: true
    },
    {
        path: '/net-shipped-customer-wise',
        screen: ScreenComponents.NetShippedStyleWise,
        checker: true
    },
    {
        path: '/customer-hold',
        screen: ScreenComponents.CustomerHold,
        checker: true
    },
    {
        path: '/missing-upc',
        screen: ScreenComponents.MissingUpc,
        checker: true
    },
    {
        path: '/customer-payment-ledger-date-wise',
        screen: ScreenComponents.CustomerPaymentLedgerDateWise,
        checker: true
    },
    {
        path: '/pending-order-summary-Ots',
        screen: ScreenComponents.PendingOrderAvailabilityBySize,
        checker: true
    },
    {
        path: '/negative-ots-order-wise',
        screen: ScreenComponents.NegativeOrderOtsWise,
        checker: true
    },
    {
        path: '/negative-ots-order-wise2',
        screen: ScreenComponents.NegativeOrderOtsWise2,
        checker: true
    },
    {
        path: '/brand',
        screen: ScreenComponents.Brand,
        checker: true
    },
    {
        path: '/sku-exists-erp',
        screen: ScreenComponents.SkuExistsErp,
        checker: true
    },
    {
        path: '/sku-exists-erp',
        screen: ScreenComponents.SkuExistsErp,
        checker: true
    },
    {
        path: '/online-orders-summary',
        screen: ScreenComponents.OnlineOrdersSummary,
        checker: true
    },
    {
        path: '/speciality-by-region',
        screen: ScreenComponents.SpecialityByRegion,
        checker: true
    },
    {
        path: '/speciality-by-state',
        screen: ScreenComponents.SpecialityByState,
        checker: true
    },
    {
        path: '/speciality-by-customer',
        screen: ScreenComponents.SpecialityByCustomer,
        checker: true
    },
    {
        path: '/ecommerce-by-style',
        screen: ScreenComponents.EcommerceByStyle,
        checker: true
    },
    {
        path: '/dl-bulk',
        screen: ScreenComponents.DLBulk,
        checker: true
    },
    {
        path: '/ww-bulk',
        screen: ScreenComponents.WWBulk,
        checker: true
    },
    {
        path: '/product-migration',
        screen: ScreenComponents.ProductMigration,
        checker: true
    },
    {
        path: '/specialty-by-style',
        screen: ScreenComponents.SpecialtyByStyle,
        checker: true
    },
    {
        path: '/routine-log',
        screen: ScreenComponents.RoutineLog,
        checker: true
    },
    {
        path: '/image-uploader-nu',
        screen: ScreenComponents.ImageUploaderNu,
        checker: true
    },
    {
        path: '/scheels-edi',
        screen: ScreenComponents.ScheelsEdi,
        checker: true
    },
    {
        path: '/profile',
        screen: ScreenComponents.Profile,
        checker: true
    },
    {
        path: '/leaderboard',
        screen: ScreenComponents.LeaderBoard,
        checker: true
    },
    {
        path: '/control-sheet2',
        screen: ScreenComponents.ControlSheet2,
        checker: true
    },
    {
        path: '/invoice-email-test',
        screen: ScreenComponents.InvoiceEmailTest,
        checker: true
    },
    {
        path: '/production-finished',
        screen: ScreenComponents.ProductionFinished,
        checker: true
    },
    {
        path: '/oms-stock-summary-style-wise',
        screen: ScreenComponents.OMSStockStyleWiseSummary,
        checker: true
    },
    {
        path: '/product-image-url',
        screen: ScreenComponents.ProductImageUrl,
        checker: true
    },
    {
        path: '/dropship-sku',
        screen: ScreenComponents.DropshipSKU,
        checker: true
    },
    {
        path: '/dropship-total',
        screen: ScreenComponents.DropshipTotal,
        checker: true
    },
    {
        path: '/customer-by-po',
        screen: ScreenComponents.CustomerbyPO,
        checker: true
    },
    {
        path: '/speciality-by-month',
        screen: ScreenComponents.SpecialityByMonth,
        checker: true
    },
    {
        path: '/add-calendar',
        screen: ScreenComponents.CalenderForm,
        checker: true
    },
    {
        path: '/calendar',
        screen: ScreenComponents.EventCalendar,
        checker: true
    },
    {
        path: '/cc-order-processing',
        screen: ScreenComponents.CCOrderProcessing,
        checker: true
    },
    {
        path: '/avalara-return',
        screen: ScreenComponents.AvalaraReturn,
        checker: true
    },
    {
        path: '/invoice-pending-pdf',
        screen: ScreenComponents.InvoicePendingPdf,
        checker: true
    },
    {
        path: '/credit-note-email',
        screen: ScreenComponents.CreditNoteEmail,
        checker: true
    },
    {
        path: '/credit-note-pdf',
        screen: ScreenComponents.CreditNoteEmailPdf,
        checker: true
    },
    {
        path: '/product-image-report-new',
        screen: ScreenComponents.ProductImageReportNew,
        checker: true
    },
    {
        path: '/business-dashboard-new',
        screen: ScreenComponents.BusinessDashboardNew,
        checker: true
    },
    {
        path: '/allocation-report',
        screen: ScreenComponents.AllocationReport,
        checker: true
    },
    {
        path: '/style-wise-detail',
        screen: ScreenComponents.StyleWiseDetail,
        checker: true
    },
    {
        path: '/collaterals',
        screen: ScreenComponents.Collaterals,
        checker: true
    },
    {
        path: '/itemcode-to-upc',
        screen: ScreenComponents.ItemCodeToUpc,
        checker: true
    },
    {
        path: '/net-shipped-inventory',
        screen: ScreenComponents.NetShippedInventory,
        checker: true
    },
    {
        path: '/fabric-wise-inventory',
        screen: ScreenComponents.FabricWiseInventory,
        checker: true
    },
    {
        path: '/style-wise-inventory',
        screen: ScreenComponents.StyleWiseInventory,
        checker: true
    },
    {
        path: '/size-curve-report',
        screen: ScreenComponents.SizeCurveReport,
        checker: true
    },
    {
        path: '/specialty-By-Booking-report',
        screen: ScreenComponents.SpecialtyByBookingReport,
        checker: true
    },
    {
        path: '/userrights-multiple',
        screen: ScreenComponents.UserRightsMultiple,
        checker: true
    },
    {
        path: '/DL-Bill',
        screen: ScreenComponents.DLBill,
        checker: true
    },
    {
        path: '/production-sku-wise-percentage',
        screen: ScreenComponents.ProductionSKUWisePercentage,
        checker: true
    },
    {
        path: '/shipped-style-wise-percentage',
        screen: ScreenComponents.ShippedStyleWisePercentage2,
        checker: true
    },
    {
        path: '/payment-receipt-report-new',
        screen: ScreenComponents.paymentReceiptReportNew,
        checker: true
    },
    {
        path: '/admin-department',
        screen: ScreenComponents.AdminDepartment,
        checker: true
    },
    {
        path: '/journal-voucher-report',
        screen: ScreenComponents.JournalVoucherReport,
        checker: true
    },
    {
        path: '/user-region',
        screen: ScreenComponents.UserRegion,
        checker: true
    },
    {
        path: '/ar-customer-payment-ledger',
        screen: ScreenComponents.ArCustomerPaymentLedger,
        checker: true
    },
    {
        path: '/payment-adjustment',
        screen: ScreenComponents.PaymentAdjustment,
        checker: true
    },
    {
        path: '/control-sheet-advanceship',
        screen: ScreenComponents.ControlSheetAdvanceShip,
        checker: true
    },
    {
        path: '/customer-adjustment-report',
        screen: ScreenComponents.CustomerAdjustmentReport,
        checker: true
    },
    {
        path: '/customer-credit-report',
        screen: ScreenComponents.CustomerCreditReport,
        checker: true
    },
    {
        path: '/return-authorization-report',
        screen: ScreenComponents.ReturnAuthorizationReport,
        checker: true
    },
    {
        path: '/customer-payment-print',
        screen: ScreenComponents.CustomerPaymentPrint,
        checker: true
    },
    {
        path: '/control-sheet-advanceship-log',
        screen: ScreenComponents.ControlSheetAdvanceShipLog,
        checker: true
    },
    {
        path: '/customer-refund-print',
        screen: ScreenComponents.CustomerRefundPrint,
        checker: true
    },
    {
        path: '/pending-style-wise-with-availability',
        screen: ScreenComponents.PendingStyleWiseWithAvailability,
        checker: true
    },
]